// client/src/pages/Weddings/steps/RentalsStep/utils/index.js

// Date & math
export const toISO = (d) => (d ? new Date(d).toISOString().slice(0, 10) : "");
export const addDaysISO = (iso, n) =>
  toISO(new Date(new Date(iso).getTime() + n * 86400000));
export const daysBetween = (startISO, endISO) => {
  const s = new Date(startISO);
  const e = new Date(endISO);
  if (Number.isNaN(s.getTime()) || Number.isNaN(e.getTime())) return 0;
  const ms = Math.max(0, e.setHours(0, 0, 0, 0) - s.setHours(0, 0, 0, 0));
  const d = Math.ceil(ms / 86400000);
  return Math.max(1, d);
};
export const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

// Recommendations
const inferBoardByTiers = (tiers) =>
  tiers <= 1 ? 12 : tiers === 2 ? 14 : tiers === 3 ? 16 : 18;
export function recommendedStandSizeIn(state, overhang = 2) {
  if (!state?.cake?.include) return null;
  const tiers = Array.isArray(state?.cake?.tiers) ? state.cake.tiers.length : 1;
  return inferBoardByTiers(tiers || 1) + overhang;
}

// Deposits
function resolveReplacementCost(product, variant) {
  const vCost = Number(variant?.replacementCost);
  const pCost = Number(product?.replacementCost);
  if (Number.isFinite(vCost) && vCost > 0) return vCost;
  if (Number.isFinite(pCost) && pCost > 0) return pCost;
  return 0;
}

export function unitDeposit(product, variant) {
  const pol = product?.depositPolicy || {};
  if (!pol || pol.type === "none") return 0;

  if (pol.type === "fixed") return Number(pol.amount) || 0;

  if (pol.type === "percent") {
    const basis = resolveReplacementCost(product, variant);
    const pct = (Number(pol.amount) || 0) / 100;
    let dep = basis * pct;
    if (Number.isFinite(pol.min)) dep = Math.max(dep, Number(pol.min));
    if (Number.isFinite(pol.max)) dep = Math.min(dep, Number(pol.max));
    return dep;
  }
  return 0;
}

export function lineDeposit(product, variant, quantity = 1) {
  const perUnit = !!product?.depositPolicy?.perUnit;
  const u = unitDeposit(product, variant);
  return perUnit ? u * Math.max(1, Number(quantity) || 1) : u;
}
